import { WILD_ID } from "./BURHistoryConstants";
import {
    IHistoryCascadeStep,
    IHistorySpin,
    IStepperFrame
} from "./BURHistoryTypes";

export interface IFrameLabels {
    start: string;
    // "Cascade", followed by the number of the step
    cascade: string;
    final: string;
}

/**
 * The grid as the player saw it land. The round's view is taken before the engine drops the Storm of the Buffalo
 * wilds in (BuffaloEngine.injectWilds, which also covers Mystery cells), so they are added here from
 * featureInfo.stormWilds, the same positions the game uses to show them. The response data is not changed.
 */
export function getStartView(spin: IHistorySpin): number[][] {
    const positions = spin.featureInfo?.stormWilds?.positions || [];
    if (!positions.length || !spin.view) {
        return spin.view;
    }
    const startView = spin.view.map((reel) => reel.slice());
    positions.forEach(({ x, y }) => {
        if (startView[x] && y >= 0 && y < startView[x].length) {
            startView[x][y] = WILD_ID;
        }
    });
    return startView;
}

// Positions come as { x: column, y: row }; the set is keyed "column,row"
export function getWinningPositions(step: IHistoryCascadeStep): Set<string> {
    const positions = new Set<string>();
    step.clusters.forEach((cluster) =>
        (cluster.positions || []).forEach((position) =>
            positions.add(`${position.x},${position.y}`)
        )
    );
    return positions;
}

/**
 * Start grid without any wins, the grid of each cascade step with its wins, then the final grid.
 * Each step's grid is the one its clusters were evaluated on (e.g. after the mystery reveal), so the first
 * cascade has its own frame even when its grid is the start grid itself.
 */
export function getSpinFrames(
    spin: IHistorySpin,
    labels: IFrameLabels
): IStepperFrame[] {
    const frames: IStepperFrame[] = [
        { label: labels.start, grid: getStartView(spin), cascadeIndex: -1 }
    ];
    (spin.cascadeSteps || []).forEach((step) => {
        if (step.gridBefore) {
            frames.push({
                label: `${labels.cascade} ${step.cascadeIndex + 1}`,
                grid: step.gridBefore,
                winning: getWinningPositions(step),
                cascadeIndex: step.cascadeIndex
            });
        }
    });
    frames.push({
        label: labels.final,
        grid: spin.finalView,
        cascadeIndex: -1
    });
    return frames;
}
